export class SimpleEventResource {
    sourceCalendar: string;

    eventId: string;
    eventStatus: string;
    eventCreated: string;
    eventCreator: string;
    eventOrganizer: string;
    eventAttendees: string;
    eventTitle: string;
    eventDescription: string;
    eventLocation: string;
    eventStart: string;
    eventEnd: string;
    eventVisibility: string;
    eventAttachments: string;

    labelledEventType: string;
    labelledCompany: string;
    extractedCompanyAttendees: string;
    simpleAttendees: string;

    constructor(map: SimpleEventResource = {} as SimpleEventResource) {
        this.sourceCalendar = map.sourceCalendar || null;

        this.eventId = map.eventId || null;
        this.eventTitle = map.eventTitle || null;
        this.eventStatus = map.eventStatus || null;
        this.eventCreated = map.eventCreated || null;
        this.eventCreator = map.eventCreator || null;
        this.eventOrganizer = map.eventOrganizer || null;
        this.eventAttendees = map.eventAttendees || null;
        this.eventDescription = map.eventDescription || null;
        this.eventLocation = map.eventLocation || null;
        this.eventStart = map.eventStart || null;
        this.eventEnd = map.eventEnd || null;
        this.eventVisibility = map.eventVisibility || null;
        this.eventAttachments = map.eventAttachments || null;

        this.labelledEventType = map.labelledEventType || null;
        this.labelledCompany = map.labelledCompany || null;
        this.extractedCompanyAttendees = map.extractedCompanyAttendees || null;
        this.simpleAttendees = map.simpleAttendees || null;
    }
}
